var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJcb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.309 10.9391C21.0174 10.9545 21.7298 10.9078 22.4353 10.9633C23.1498 11.0966 23.322 12.1782 22.6872 12.5325C22.2541 12.7659 21.7396 12.6194 21.2701 12.6606H20.309V10.9391ZM22.8449 8.99054C23.0022 9.54603 22.4668 10.0448 21.9318 9.96828H20.309C20.3204 9.44443 20.2868 8.87585 20.3255 8.37958C20.9756 8.39789 21.6316 8.34224 22.2779 8.40868C22.5556 8.47845 22.788 8.70673 22.8449 8.99054ZM26.7501 0.752724C26.7803 1.81358 26.7545 2.9305 26.7631 4.01287C26.7611 8.4134 26.7674 12.8138 26.7597 17.2146C26.7312 18.8638 25.2696 20.2968 23.6318 20.3297C21.9924 20.3364 20.3528 20.3308 18.7132 20.3326V13.6799C20.4996 13.6707 22.287 13.6986 24.0727 13.666C24.901 13.614 25.8084 13.0674 25.847 12.1558C25.9445 11.2402 25.0813 10.6069 24.2618 10.5069C23.9468 10.4987 23.956 10.4151 24.2618 10.3786C25.0434 10.2097 25.6572 9.40067 25.4273 8.59047C25.2313 7.73832 24.2894 7.4085 23.506 7.41014C21.9087 7.39929 20.311 7.40862 18.7136 7.40547C18.7239 6.16349 18.692 4.92018 18.7307 3.67912C18.8573 2.05968 20.3557 0.724174 21.9704 0.753148C23.5639 0.752906 25.157 0.752906 26.7501 0.752845V0.752724Z",
    fill: "url(#paint0_linear_1142_85002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.661629 3.84678C0.702424 2.20019 2.17026 0.778907 3.80594 0.754842C5.43926 0.749811 7.07281 0.754115 8.70613 0.75266C8.70165 6.26181 8.71498 11.7716 8.6994 17.2804C8.63648 18.907 7.18465 20.3012 5.56679 20.33C3.93038 20.3359 2.29379 20.3308 0.657326 20.3325V13.4555C2.24688 13.831 3.91378 13.9909 5.53539 13.7418C6.50472 13.5858 7.56527 13.1098 7.89345 12.1042C8.13494 11.244 7.99898 10.3386 8.03492 9.45577V7.40541H5.22855C5.21594 8.76146 5.25437 10.1199 5.20825 11.4743C5.1326 12.3068 4.30815 12.8358 3.52298 12.8075C2.54923 12.8178 0.619622 12.1018 0.619622 12.1018C0.614772 9.56112 0.647869 6.37929 0.661629 3.84702V3.84678Z",
    fill: "url(#paint1_linear_1142_85002)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75252 8.23248C9.6048 8.26382 9.72282 7.72931 9.68506 7.52654C9.69512 6.2445 9.66402 4.96106 9.70221 3.67993C9.82841 2.05364 11.3383 0.7148 12.9596 0.752867H17.7342C17.7297 6.26202 17.743 11.7718 17.7275 17.2806C17.6645 18.9072 16.2126 20.3013 14.5947 20.3302C12.9582 20.3364 11.3216 20.3312 9.68499 20.3327V12.7981C10.8027 13.7151 12.3218 13.8579 13.7143 13.8604C14.764 13.86 15.8077 13.6982 16.8271 13.4561V12.0757C15.6782 12.6483 14.3277 13.012 13.0542 12.683C12.1658 12.4619 11.5209 11.6033 11.5352 10.6865C11.4323 9.73305 11.9912 8.72645 12.9281 8.44301C14.0914 8.07882 15.3593 8.35736 16.4497 8.83083C16.6833 8.95316 16.9205 9.10488 16.827 8.71439V7.62941C15.0033 7.19551 13.0625 7.03585 11.2303 7.50787C10.7 7.65747 10.1833 7.88436 9.75252 8.23261V8.23248Z",
    fill: "url(#paint2_linear_1142_85002)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1142_85002",
    x1: 18.6582,
    y1: 10.124,
    x2: 26.7124,
    y2: 10.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1142_85002",
    x1: 0.486077,
    y1: 10.7301,
    x2: 8.57416,
    y2: 10.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1142_85002",
    x1: 9.67319,
    y1: 10.3138,
    x2: 17.7327,
    y2: 10.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJcb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JCB.8d71e198aed7fae7ba131dc90cd8b606.svg";